import React,{useState,useEffect} from 'react'
import {Row,Col,Modal} from 'react-bootstrap'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { optionsShowtt, optionsStatus, optionsdept } from '../../Helper'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment'
import ReactPaginate from 'react-paginate'
import PillSmall from '../../subComponents/CustomSubComponents/PillSmall'
import TextField from '@mui/material/TextField';
import Purplebutton from '../desktop/subComponent/Purplebutton';
import { validationComp, validationDrp } from '../../subComponents/CustomSubComponents/ValidationComp'

import { hrPolicyApi } from '../../../utils/AdminDashApi/HRPolicyApi'
import MobileInputSubComp from './sub_components/MobileInputSubComp';
const HRPoliciesCompmb = () => {
    const [show,setShow] = useState(10)
   
    const [departmentMod1,setdepartmentMod1]= useState("")
    const [labeldepartmentMod1,setlabeldepartmentMod1]= useState("")
    const [borderdepartmentMod1,setborderdepartmentMod1]= useState("")
    const [roleMod1,setroleMod1]= useState("")
    const [labelroleMod1,setlabelroleMod1]= useState("")
    const [borderroleMod1,setborderroleMod1]= useState("")
    const [policynameMod1,setpolicynameMod1]= useState("")
    const [labelpolicynameMod1,setlabelpolicynameMod1]= useState("")
    const [borderpolicynameMod1,setborderpolicynameMod1]= useState("")

    const [policynameMod2, setpolicynameMod2] = useState("")
    const [labelpolicynameMod2, setlabelpolicynameMod2] = useState("")
    const [borderpolicynameMod2, setborderpolicynameMod2] = useState("")

    const [borderempnameMod2,setborderempnameMod2] = useState("")
    const [labelempnameMod2,setlabelempnameMod2] = useState("")
    const [idMod2,setidMod2] = useState("")
    const [borderidMod2,setborderidMod2] = useState("")
    const [labelidMod2,setlabelidMod2] = useState("")
    const [emailMod2,setemailMod2]= useState("")
    const [labelemailMod2,setlabelemailMod2]= useState("")
    const [borderemailMod2,setborderemailMod2]= useState("")
    const [departmentMod2,setdepartmentMod2]= useState("")
    const [labeldepartmentMod2,setlabeldepartmentMod2]= useState("")
    const [borderdepartmentMod2,setborderdepartmentMod2]= useState("")
    const [roleMod2,setroleMod2]= useState("")
    const [labelroleMod2,setlabelroleMod2]= useState("")
    const [borderroleMod2,setborderroleMod2]= useState("")
    const [statusMod2,setstatusMod2]= useState("")
    const [labelstatusMod2,setlabelstatusMod2]= useState("")
    const [borderstatusMod2,setborderstatusMod2]= useState("")
  
    const [descriptionMod1,setdescriptionMod1]= useState("")
    const [labeldescriptionMod1,setlabeldescriptionMod1]= useState("")
    const [borderdescriptionMod1,setborderdescriptionMod1]= useState("")

    
    const [descriptionMod2,setdescriptionMod2]= useState("")
    const [labeldescriptionMod2,setlabeldescriptionMod2]= useState("")
    const [borderdescriptionMod2,setborderdescriptionMod2]= useState("")

    const [dateOfCreationMod1,setdateOfCreationMod1]= useState("")
    const [labeldateOfCreationMod1,setlabeldateOfCreationMod1]= useState("")
    const [borderdateOfCreationMod1,setborderdateOfCreationMod1]= useState("")
    const [dateOfExpireMod1,setdateOfExpireMod1]= useState("")
    const [labeldateOfExpireMod1,setlabeldateOfExpireMod1]= useState("")
    const [borderdateOfExpireMod1,setborderdateOfExpireMod1]= useState("")

    const [dateOfCreationMod2,setdateOfCreationMod2]= useState("")
  const [labeldateOfCreationMod2,setlabeldateOfCreationMod2]= useState("")
  const [borderdateOfCreationMod2,setborderdateOfCreationMod2]= useState("")
  const [dateOfExpireMod2,setdateOfExpireMod2]= useState("")
  const [labeldateOfExpireMod2,setlabeldateOfExpireMod2]= useState("")
  const [borderdateOfExpireMod2,setborderdateOfExpireMod2]= useState("")
   

    const [show2,setShow2] = useState(false)
    const [show3,setShow3] = useState(false)

    const handleClose=()=>{
        setShow2(false)
    }

   

    const handlesaveModal1=()=>{
      //Mod1validation
     
  
      validationDrp(departmentMod1,setlabeldepartmentMod1,setborderdepartmentMod1,"Department Required")    
      validationComp(descriptionMod1,setlabeldescriptionMod1,setborderdescriptionMod1,"Description Required")
      validationDrp(policynameMod1,setlabelpolicynameMod1,setborderpolicynameMod1,"Policy Name Required")
      validationComp(dateOfCreationMod1,setlabeldateOfCreationMod1,setborderdateOfCreationMod1,"Creation Date Required")
      validationComp(dateOfExpireMod1,setlabeldateOfExpireMod1,setborderdateOfExpireMod1,"Expire Date Required")
    }
    const handlesaveModal2=()=>{
      //Mod2validation
     
      validationDrp(departmentMod2,setlabeldepartmentMod2,setborderdepartmentMod2,"Department Required")
     validationComp(descriptionMod2,setlabeldescriptionMod2,setborderdescriptionMod2,"Description Required")
     validationDrp(policynameMod2,setlabelpolicynameMod2,setborderpolicynameMod2,"Policy Name Required")
     validationComp(dateOfCreationMod2,setlabeldateOfCreationMod2,setborderdateOfCreationMod2,"Creation Date Required")
     validationComp(dateOfExpireMod2,setlabeldateOfExpireMod2,setborderdateOfExpireMod2,"Expire Date Required")
     
    }

    const handlecross=(fullItem)=>{

    }

    const drpfuncshow=(myval,id)=>{
        setShow(myval)        
      }
    const drpfuncdeptMod1 = (myval,myid) =>{
      setdepartmentMod1(myval)
    }
    const drpfuncpolicynameMod1 = (myval,myid)=>{
      setpolicynameMod1(myval)

    }
    const drpfuncpolicynameMod2 = (myval,myid)=>{
      setpolicynameMod2(myval)

    }
     
    const drpfuncdeptMod2 = (myval,myid) =>{
      setdepartmentMod2(myval)
    }
    const drpfuncroleMod2 = (myval,myid)=>{
      setroleMod2(myval)

    }
     
      const handleClose2=()=>{
        setShow3(false)
      }

      const handleCretionDateMod1 = (newvaldob) => {
        console.log(newvaldob)
        // setdateofbirthnew(moment(newvaldob).format("YYYY-MM-DD"))
        if (newvaldob != null) {

            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setdateOfCreationMod1(moment(dtdobfinalc).format("YYYY-MM-DD"))
            // setdateofbirthnew(newvaldob)
        }
    }
      const handleExpireDateMod1 = (newvaldob) => {
        console.log(newvaldob)
        // setdateofbirthnew(moment(newvaldob).format("YYYY-MM-DD"))
        if (newvaldob != null) {

            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setdateOfExpireMod1(moment(dtdobfinalc).format("YYYY-MM-DD"))
            // setdateofbirthnew(newvaldob)
        }
    }
    const handleCretionDateMod2 = (newvaldob) => {
        console.log(newvaldob)
        // setdateofbirthnew(moment(newvaldob).format("YYYY-MM-DD"))
        if (newvaldob != null) {

            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setdateOfCreationMod2(moment(dtdobfinalc).format("YYYY-MM-DD"))
            // setdateofbirthnew(newvaldob)
        }
    }
      const handleExpireDateMod2 = (newvaldob) => {
        console.log(newvaldob)
        // setdateofbirthnew(moment(newvaldob).format("YYYY-MM-DD"))
        if (newvaldob != null) {

            var dtofbrth = newvaldob.$M + 1;
            var dtdobfinalc = newvaldob.$y + '-' + dtofbrth + '-' + newvaldob.$D;
            setdateOfExpireMod2(moment(dtdobfinalc).format("YYYY-MM-DD"))
            // setdateofbirthnew(newvaldob)
        }
    }

      const [mainpagesearch,setmainpagesearch] = useState("")
  const handlemainpagesearch=(e)=>{
    setmainpagesearch(e.target.value)
  }
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)
  const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
  const [pageCount2, setPageCount2] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2,setitemsPerPage2] = useState(10);
  
  const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2,setpaginatenumselected2] = useState(0)
  const [filteredArr,setfilteredArr] = useState(hrPolicyApi.data)
  const [tempfilteredarr,settempfilteredarr] = useState([])
  let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
  

  useEffect(() => {
    const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
    const tempArr = filteredArr.slice(itemOffsetfiltered, endOffsetfiltered);
    settempfilteredarr(tempArr);
    setPageCountfiltered(Math.ceil(filteredArr.length / itemsPerPagefiltered));
    setitemsPerPagefiltered(show?show:10)
    //flag2
  }, [itemOffsetfiltered, itemsPerPagefiltered, filteredArr,show]);

      const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % hrPolicyApi.data.length;        
        setpaginatenumselected(event.selected);
        setItemOffset(newOffset);
      };
      const handlePageClickfiltered = (event) => {
        const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
        setpaginatenumselectedfiltered(event.selected);
        setItemOffsetfiltered(newOffsetf);
      };
      const handleAddNewSalary=()=>{
        setShow2(true)
      }
      //start
  return (
    <>
    <div className="felxvaluecompmbmain">
        <div className="studentdashboardmobilewrapper">
            <div className="mobilecontainer">
                <div className="adminmbheading">
                    <h3>Policies</h3>
                </div>
                <div className="admbwrap">
                    <Purplebutton clickfunc={handleAddNewSalary} w="100%" h="40px" btnname="+ Create New Policy" />
                </div>
                <div className="admbwrap pb0">
                <Row>

                <MobileInputSubComp col="4" name="Show" direct="left">
                    <div className="dropdownwrapper">
                    <Dropdown2 func={drpfuncshow} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsShowtt}/>
                    </div>
                </MobileInputSubComp>
                <MobileInputSubComp col="8" name="Search" direct="right">
                <div className="wrap">
                    <input type="text" placeholder="Search" value={mainpagesearch} onChange={handlemainpagesearch}/>
                    <img src="./assets/images/dashboards/adminDashboard/flexvalue/search.png" alt="" />

                    </div>
                </MobileInputSubComp>

                </Row>
                </div>
                <div className="admbwrap pr0">
                    <div className="tablewrapscroll">
                    <div className="flexvaluetable bigtable1600 widecell">
                    <table>
                      <thead>
                        <tr>
                            {
                              hrPolicyApi.heading.map((item,key)=>{
                                return(
                                  <th key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            tempfilteredarr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  <td>{item.policyname}</td>
                                  <td>{item.department}</td>
                                  <td style={{width:"30%"}}>{item.description}</td>
                                  <td>{item.created}</td>
                                  <td>{item.expire}</td>
                                  <td className='text-center'>
                                    <img style={{width:"16px"}} onClick={()=>setShow3(true)} src={item.action} alt="" />
                                  </td>
                                </tr>
                              )
                            })
                            :
                            ""
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
                    </div>
                </div>
                <div className="admbwrap">
                <Row>
                <Col lg={10} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={2}
                      pageCount={pageCountfiltered}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffset+1} to {itemOffset+10} of {hrPolicyApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={2}
                      pageCount={pageCount}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                    }
                </Col>
               
              </Row>
                </div>

                {/* modal1ori */}

               <Modal dialogClassName="mymodal" show={show2} onHide={handleClose} backdrop="static"
              keyboard={false}>
               
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Policies</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={10} className="m-auto">
                    <Row>
                        <MobileInputSubComp col="12" name="Policy Name" direct="center">

                            <div className="dropdownwrapper" >

                                <Dropdown2 err={borderpolicynameMod1} func={drpfuncpolicynameMod1} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsStatus} />
                            </div>
                            <label>{labelpolicynameMod1}</label>
                        </MobileInputSubComp>

                        <MobileInputSubComp col="12" name="Department" direct="center">

                            <div className="dropdownwrapper" >

                                <Dropdown2 err={borderdepartmentMod1} func={drpfuncdeptMod1} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsdept} />
                            </div>
                            <label>{labeldepartmentMod1}</label>
                        </MobileInputSubComp>

                        <MobileInputSubComp col="12" name="Creation Date" direct="center">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>

                                <DatePicker
                                    value={dateOfCreationMod1}
                                    onChange={(newvaldob) => handleCretionDateMod1(newvaldob)}
                                    renderInput={(params) => <TextField {...params} style={borderdateOfCreationMod1 == true ? { border: "1px solid #ED1C24", borderRadius: "10px" } : {}} inputProps={{
                                        ...params.inputProps,
                                        placeholder: "Date of Birth"
                                    }} error={false} />}
                                />
                                <label>{labeldateOfCreationMod1}</label>

                            </LocalizationProvider>
                        </MobileInputSubComp>

                        <MobileInputSubComp col="12" name="Expire Date" direct="center">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>

                                <DatePicker
                                    value={dateOfExpireMod1}
                                    onChange={(newvaldob) => handleExpireDateMod1(newvaldob)}
                                    renderInput={(params) => <TextField {...params} style={borderdateOfExpireMod1 == true ? { border: "1px solid #ED1C24", borderRadius: "10px" } : {}} inputProps={{
                                        ...params.inputProps,
                                        placeholder: "Expire Date"
                                    }} error={false} />}
                                />
                                <label>{labeldateOfExpireMod1}</label>

                            </LocalizationProvider>
                        </MobileInputSubComp>



                        <MobileInputSubComp col="12" name="Description" direct="center">

                            <textarea style={borderdescriptionMod1 ? { borderColor: "rgb(237, 28, 36)", width: "100%", height: "100px" } : { borderColor: "rgba(0,0,0,0.2)", width: "100%", height: "100px" }} className="textbox" type="text" name="description" value={descriptionMod1} onChange={(e) => setdescriptionMod1(e.target.value)} placeholder='' />
                            <label>{labeldescriptionMod1}</label>
                        </MobileInputSubComp>






                    </Row>
                   
                    </Col>
                    
                  </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal1}>
                    Save
                  </button>
                </Modal.Footer>

                
              </Modal>
               {/* modal2ori */}

               <Modal dialogClassName="mymodal" show={show3} onHide={handleClose2} backdrop="static"
              keyboard={false}>
               
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Policies</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Row>
                    <Col lg={10} className="m-auto">
                    <Row>
                        <MobileInputSubComp col="12" name="Policy Name" direct="center">

                            <div className="dropdownwrapper" >

                                <Dropdown2 err={borderpolicynameMod2} func={drpfuncpolicynameMod2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsStatus} />
                            </div>
                            <label>{labelpolicynameMod2}</label>
                        </MobileInputSubComp>

                        <MobileInputSubComp col="12" name="Department" direct="center">

                            <div className="dropdownwrapper" >

                                <Dropdown2 err={borderdepartmentMod2} func={drpfuncdeptMod2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsdept} />
                            </div>
                            <label>{labeldepartmentMod2}</label>
                        </MobileInputSubComp>

                        <MobileInputSubComp col="12" name="Creation Date" direct="center">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>

                                <DatePicker
                                    value={dateOfCreationMod2}
                                    onChange={(newvaldob) => handleCretionDateMod2(newvaldob)}
                                    renderInput={(params) => <TextField {...params} style={borderdateOfCreationMod2 == true ? { border: "1px solid #ED1C24", borderRadius: "10px" } : {}} inputProps={{
                                        ...params.inputProps,
                                        placeholder: "Date of Birth"
                                    }} error={false} />}
                                />
                                <label>{labeldateOfCreationMod2}</label>

                            </LocalizationProvider>
                        </MobileInputSubComp>

                        <MobileInputSubComp col="12" name="Expire Date" direct="center">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>

                                <DatePicker
                                    value={dateOfExpireMod2}
                                    onChange={(newvaldob) => handleExpireDateMod2(newvaldob)}
                                    renderInput={(params) => <TextField {...params} style={borderdateOfExpireMod2 == true ? { border: "1px solid #ED1C24", borderRadius: "10px" } : {}} inputProps={{
                                        ...params.inputProps,
                                        placeholder: "Expire Date"
                                    }} error={false} />}
                                />
                                <label>{labeldateOfExpireMod2}</label>

                            </LocalizationProvider>
                        </MobileInputSubComp>



                        <MobileInputSubComp col="12" name="Description" direct="center">

                            <textarea style={borderdescriptionMod2 ? { borderColor: "rgb(237, 28, 36)", width: "100%", height: "100px" } : { borderColor: "rgba(0,0,0,0.2)", width: "100%", height: "100px" }} className="textbox" type="text" name="description" value={descriptionMod2} onChange={(e) => setdescriptionMod2(e.target.value)} placeholder='' />
                            <label>{labeldescriptionMod2}</label>
                        </MobileInputSubComp>
                    </Row>
                    </Col>
                  </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal2}>
                    Update
                  </button>
                </Modal.Footer>

                
              </Modal>
            </div>
        </div>
    </div>
    </>
  )
}

export default HRPoliciesCompmb